/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-10 08:33:48
 */

import * as Vue from "vue-tsx-support";
import {Component, Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import Modal from "src/types/iview/Modal";
import Button from "src/types/iview/Button";
import {modalFactory} from "src/util/vueExtend";
import { Integer } from 'src/types/base';
import ControlRecord from './controlRecord';
import { router } from 'src/router';

export namespace ControlRecordVOI {
	export interface PropsI {
		mn: string

		saveSuccess? (): void

		cancel? (): void
	}

	export interface FormDataI {
		id?: Integer
		"name":string,
	}
}

@Component
class ControlRecordModal extends Vue.Component<ControlRecordVOI.PropsI> {
	@Prop({
		type: Function
	})
	cancel!: () => void


	@Prop({
		type: String
	})
	mn!: string

	@Prop({
		type: Function
	})
	saveSuccess!: () => void

	visible: boolean = false

	loading: boolean = false

	formData: ControlRecordVOI.FormDataI = {
		name: '',
	}
	rules: any = {
		name: [
			{required: true, message: '请输入名称', trigger: 'change'}
		],
	}

	close () {
		this.cancel && this.cancel()
		this.closeModal()
	}

	closeModal() {
		this.visible = false
		this.$emit('close', false)
    }


	render (h) {
		return (
			<Modal
				title="操作记录"
                width="1000"
                class="wqms-modal-fix-height"
				v-model={this.visible}
				mask-closable={false}
				on-on-cancel={this.close}
			>
                <ControlRecord mn={this.mn}></ControlRecord>
				<div slot="footer">
					<Button type="primary" ghost on-click={this.close}>取消</Button>
				</div>
			</Modal>
		);
	}
}

export default function alertControlRecordModal (mn:string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			modalFactory<ControlRecordVOI.PropsI>(ControlRecordModal)({
                mn,
				saveSuccess () {
					resolve(true)
				},
				cancel () {
					resolve(false)
				}
			})
		})
	}
